import {
  DomeCallback,
  ErrorCallback,
  GetMarksCallback,
  HistoryCallback,
  HistoryDepth,
  IBasicDataFeed,
  LibrarySymbolInfo,
  Mark,
  OnReadyCallback,
  ResolutionBackValues,
  ResolveCallback,
  SearchSymbolsCallback,
  ServerTimeCallback,
  SubscribeBarsCallback,
  TimescaleMark
} from '../../../../static/charting_library/charting_library.min';
import { supportedResolutions } from '../config';
import { EX3HistoryProvider } from './HistoryProvider';
import { EX3StreamProvider } from './StreamProvider';

export class EX3DataFeed implements IBasicDataFeed {
  private priceDecimals = 0;
  private baseTokenDecimals = 0;
  private klineCanisterId = '';
  private historyProvider: EX3HistoryProvider;
  private streamProvider: EX3StreamProvider;

  constructor(
    klineCanisterId: string,
    priceDecimals: number,
    baseTokenDecimals: number
  ) {
    this.klineCanisterId = klineCanisterId;
    this.priceDecimals = priceDecimals;
    this.baseTokenDecimals = baseTokenDecimals;
    this.historyProvider = new EX3HistoryProvider(
      klineCanisterId,
      priceDecimals,
      baseTokenDecimals
    );

    this.streamProvider = new EX3StreamProvider(
      klineCanisterId,
      priceDecimals,
      baseTokenDecimals
    );
  }
  searchSymbols(
    userInput: string,
    exchange: string,
    symbolType: string,
    onResult: SearchSymbolsCallback
  ): void {
    console.debug('searchSymbols', userInput, exchange, symbolType);
  }
  resolveSymbol(
    symbolName: string,
    onResolve: ResolveCallback,
    onError: ErrorCallback
  ): void {
    const split_data = symbolName.split(/[:/]/);
    const symbol_stub: LibrarySymbolInfo = {
      name: symbolName,
      description: '',
      type: 'crypto',
      session: '24x7',
      timezone: 'Etc/UTC',
      ticker: symbolName,
      // exchange: split_data[0],
      minmov: 1,
      pricescale: 100000000,
      has_intraday: true,
      intraday_multipliers: ['1', '60'],
      supported_resolutions: supportedResolutions,
      volume_precision: 8,
      data_status: 'streaming',
      full_name: '',
      exchange: '',
      listed_exchange: ''
    };

    if (split_data[1].match(/USD|EUR|JPY|AUD|GBP|KRW|CNY/)) {
      symbol_stub.pricescale = 100;
    }
    setTimeout(function () {
      onResolve(symbol_stub);
      // console.log('Resolving that symbol....', symbol_stub)
    }, 0);
    // onResolveErrorCallback('Not feeling it today')
  }
  getBars(
    symbolInfo: LibrarySymbolInfo,
    resolution: string,
    rangeStartDate: number,
    rangeEndDate: number,
    onResult: HistoryCallback,
    onError: ErrorCallback,
    isFirstCall: boolean
  ): void {
    console.debug(`ex3 DataFeed: getBars ${resolution}`);
    this.historyProvider
      .getBars(
        symbolInfo,
        resolution,
        rangeStartDate,
        rangeEndDate,
        isFirstCall
      )
      .then(bars => {
        if (bars.length) {
          onResult(bars, { noData: false });
        } else {
          onResult(bars, { noData: true });
        }
      })
      .catch(err => {
        console.log({ err });
        onError(err);
      });
  }
  subscribeBars(
    symbolInfo: LibrarySymbolInfo,
    resolution: string,
    onTick: SubscribeBarsCallback,
    listenerGuid: string,
    onResetCacheNeededCallback: () => void
  ): void {
    console.debug(`ex3 subscribeBars ${resolution}`);
    this.streamProvider.subscribeBars(
      symbolInfo,
      resolution,
      onTick,
      listenerGuid,
      onResetCacheNeededCallback
    );
  }
  unsubscribeBars(listenerGuid: string): void {
    console.debug(`unsubscribeBars`);
    this.streamProvider.unsubscribeBars(listenerGuid);
  }
  subscribeDepth?(
    symbolInfo: LibrarySymbolInfo,
    callback: DomeCallback
  ): string {
    throw new Error('Method not implemented.');
  }
  unsubscribeDepth?(subscriberUID: string): void {
    throw new Error('Method not implemented.');
  }
  onReady(callback: OnReadyCallback): void {
    setTimeout(
      () =>
        callback({
          supported_resolutions: supportedResolutions
        }),
      0
    );
  }
}
